import PropTypes from 'prop-types';
import {
  Grid,
  Divider,
  makeStyles,
} from '@material-ui/core';
import { FieldArray } from 'formik';
import RoundedButton from 'components/Shared/RoundedButton';
import { EMPTY_ADDRESS } from 'components/Shared/constants';
import AddressForm from '../../AddressForm';
import { useDispatch, useSelector } from 'react-redux';
import FormikTextFieldWithClearError from '../../../../FormikFields/FormikTextFieldWithClearError';
import { setAccountBackendErrors } from '../../../../../redux_store';

const useStyles = makeStyles((theme) => ({
  title: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
}));

const OtherAddressesSection = ({
                                 otherAddresses,
                                 clearBackendError,
                                 disabled = false,
                               }) => {
  const { en: { forms } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { backendErrors } = useSelector((state) => state.accountEditing);
  const setBackendErrors = (newErrors) => {
    dispatch(setAccountBackendErrors(newErrors));
  }

  const handleAddressRemove = (arrayHelpers, index) => () => {
    arrayHelpers.remove(index);
  };

  const handleAddressAdd = (arrayHelpers) => () => {
    arrayHelpers.push({ ...EMPTY_ADDRESS });
  };

  const renderOtherAddresses = (arrayHelpers) => (
    <>
      {otherAddresses.map((address, index) => {
        return (
          <Grid key={index} container direction='column' alignItems='flex-start'>
            <Grid item xs={12} sm={8} md={8} lg={8}>
              <FormikTextFieldWithClearError
                type='text'
                name={`otherAddresses[${index}].name`}
                label={forms.name}
                backendError={backendErrors[`otherAddresses[${index}].name`]}
                fullWidth={true}
                disabled={disabled}
                clearBackendError={clearBackendError}
                required
              />
            </Grid>
            <AddressForm
              prefix={`otherAddresses[${index}]`}
              backendErrors={backendErrors}
              disabled={disabled}
              clearBackendError={clearBackendError}
              onRemove={handleAddressRemove(arrayHelpers, index)}
            />
            <Divider className={classes.divider} />
          </Grid>
        );
      })}
      <RoundedButton
        variant='contained'
        color='primary'
        size='small'
        disabled={disabled}
        onClick={handleAddressAdd(arrayHelpers)}
        className={classes.addBtn}
      >
        {forms.addAddress}
      </RoundedButton>
    </>
  );

  return <FieldArray name='otherAddresses' render={renderOtherAddresses} />;
};

OtherAddressesSection.propTypes = {
  otherAddresses: PropTypes.array,
  clearBackendError: PropTypes.func,
  disabled: PropTypes.bool,
};

OtherAddressesSection.defaultProps = {
  otherAddresses: [],
};

export default OtherAddressesSection;
